import React, { useEffect, useState } from "react"
import Sidebar from "../components/sidebar"
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Topbar from "../components/topbar";
import Pagination from "../components/Pagination";
import { errorMessage, postUserLog } from "../hooks/UserLogs";
import ConfirmModal from "../components/confirmModal";
export default function Staff() {
    const [view, setView] = useState(false);
    const [totalPage, setTotalPage] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [ListStaffs, setListStaffs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [email, setEmail] = useState("");
    const [emailUp, setEmailUp] = useState("");
    const [lastName, setLastName] = useState("");
    const [firstName, setFirstName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [login, setLogin] = useState("");
    const [profil, setProfil] = useState("");
    const [addresse, setAddress] = useState("");
    const [agentType, setAgentType] = useState("");
    const [phone, setPhone] = useState("");
    const [phoneSh, setPhoneSh] = useState("");
    const [password, setPassword] = useState("");
    const [errorForm, setErrorForm] = useState({});
    const [ErrorMsg, setErrorMsg] = useState("Une erreur s'est produite");
    const [showError, setShowError] = useState(false);
    const [idUp, setIdUp] = useState('');
    const [isActive, setIsActive] = useState(false);
    const [idUser, setIdUser] = useState('');
    const [isBlocked, setIsBlocked] = useState(false);

    const [showModalConfirmActive, setShowModalConfirmActive] = useState(false);
    const [showModalConfirmBlocked, setShowModalConfirmBlocked] = useState(false);

    const handleShowConfirmActive = (id, isActive) => {
        setShowModalConfirmActive(true);
        setIdUser(id);
        setIsActive(isActive);
    }

    const handleShowConfirmBlocked = (id, isBlocked) => {
        setShowModalConfirmBlocked(true);
        setIdUser(id);
        setIsBlocked(isBlocked);
    }

    const handleCloseConfirmActive = () => setShowModalConfirmActive(false);
    const handleCloseConfirmBlocked = () => setShowModalConfirmBlocked(false);

    const bUrl = process.env.REACT_APP_B_URL;

    const axiosInstance = axios.create({
                    withCredentials: true,
                  })

    let header =
    {
        'Content-Type': 'application/json'
    };

    const navigate = useNavigate();
    const viewClose = () => {
        setView(false)
    }
    const viewOpen = () => {
        setView(true)
    }
    const handleCloseError = () => {

        setShowError(false);
    }
    const handleClose = () => {
        setErrorForm({});

        setIdUp('');
        setAddress('');
        setMiddleName('');
        setLastName('');
        setFirstName('');
        setProfil('');
        setEmailUp('');
        setLogin('');
        setPhone('');
        setAddress('');
        setPassword('')
        setView(false)

    }
    const viewUpdate = (id, firstName, lastName, middleName, profile, address, login, phone, email) => {
        setIdUp(id);
        setAddress(address);
        setMiddleName(middleName);
        setLastName(lastName);
        setFirstName(firstName);
        setProfil(profile);
        setEmailUp(email);
        setLogin(login);
        setPhone(phone);
        setAddress(address);
        setView(true)
    }
    const updateForm = () => {
        let error = {};
        let isValid = true;
        if (emailUp == "") {
            error.emailUp = "Le champ est obligatoire!";
            isValid = false;
        }
        if (firstName == "") {
            error.firstName = "Le champ est obligatoire!";
            isValid = false;
        }
        if (lastName == "") {
            error.lastName = "Le champ est obligatoire!";
            isValid = false;
        }

        if (password == "") {
            error.password = "Le champ est obligatoire!";
            isValid = false;
        }

        if (addresse == "") {
            error.address = "Le champ est obligatoire!";
            isValid = false;
        }

        if (login == "") {
            error.login = "Le champ est obligatoire!";
            isValid = false;
        }

        if (phone == "") {
            error.phone = "Le champ est obligatoire!";
            isValid = false;
        }

        if (profil == "") {
            error.profil = "Le champ est obligatoire!";
            isValid = false;
        }

        setErrorForm(error);

        if (isValid) {
            setIsLoading(true);
            axiosInstance.put(bUrl + "/agent-owner?idOwnerAgent=" + idUp,
                //birthDay: birthDay,
                {
                    "firstName": firstName,
                    "lastName": lastName,
                    "middleName": middleName,
                    "phone": phone,
                    "email": emailUp,
                    "login": login,
                    "password": password,
                    "profil": profil,
                    "address": addresse,
                    "agentType": agentType,
                }
                , { header: header })
                .then(function (response) {
                    console.log(response)
                    //getDayOffDayEmmp(idEmp);
                    setIsLoading(false)

                    handleClose()
                    if (response?.data?.isError) {
                        const msg = errorMessage(response?.data?.code)
                        setErrorMsg(msg);
                        setShowError(true);
                    } else {
                        getListStaffs(email, phoneSh);
                    }

                })
                .catch(function (err) {
                    if (err?.response?.status == 401 || err?.response?.status == 403) {
                        setErrorMsg("Vous n'étes pas autorisé à faire cette opération!!")
                        setShowError(true);
                      } else {
                        let msg = errorMessage + ' ' + err?.response?.status ? (err?.response?.status) : '';
                        setErrorMsg(msg);
                        setShowError(true);
                      }
                    setIsLoading(false)

                    console.log(err);
                    
                });
        }
    };

    const activeOrDeactiveUser = async () => {

        const response = await axiosInstance.put(bUrl + "/agent-owner/activate-or-deactivate", {
            "fkIdStaff": sessionStorage.getItem("idUser"),
            "idUser": idUser
        }).catch((err) => {
            if (err?.response?.status == 401 || err?.response?.status == 403) {
                setErrorMsg("Vous n'étes pas autorisé à faire cette opération!!")
                setShowError(true);
              } else {
                let msg = errorMessage + ' ' + err?.response?.status ? (err?.response?.status) : '';
                setErrorMsg(msg);
                setShowError(true);
              }
            setIsLoading(false)

            console.log(err);

        });
        if (response) {

            setIsLoading(false);
            handleCloseConfirmActive()
            if (response?.data?.isError) {
                const msg = errorMessage(response?.data?.code)
                setErrorMsg(msg);
                setShowError(true);
            } else {
                getListStaffs(email, phoneSh);
                await postUserLog(bUrl + "/userLogs/addUserLogs", (isActive) ? 'Activate staff user' : 'Deactivate staff user', response.data.body.login);
            }

        }

    }

    const phonetOnchange = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setPhone(e.target.value)
        }
    }

    const blokeOrDeblokeUser = async () => {

        const response = await axiosInstance.put(bUrl + "/agent-owner/block-or-deblock", {
            "fkIdStaff": sessionStorage.getItem("idUser"),
            "idUser": idUser
        }).catch((err) => {
            if (err?.response?.status == 401 || err?.response?.status == 403) {
                setErrorMsg("Vous n'étes pas autorisé à faire cette opération!!")
                setShowError(true);
              } else {
                let msg = errorMessage + ' ' + err?.response?.status ? (err?.response?.status) : '';
                setErrorMsg(msg);
                setShowError(true);
              }
            setIsLoading(false)

        });
        if (response) {
            if (response.status == 401) {
                navigate('/backoffice/login');
            }
           
            setIsLoading(false);
            handleCloseConfirmBlocked()
            if (response?.data?.isError) {
                const msg = errorMessage(response?.data?.code)
                setErrorMsg(msg);
                setShowError(true);
            }
            else {
                getListStaffs(email, phoneSh);
                await postUserLog(bUrl + "/userLogs/addUserLogs", (isActive) ? 'blocked staff user' : 'deblocked staff user', response.data.body.login);
            }
        }

    }

    const addForm = async () => {
        let error = {};
        let isValid = true;
        if (emailUp == "") {
            error.emailUp = "Le champ est obligatoire!";
            isValid = false;
        }
        if (firstName == "") {
            error.firstName = "Le champ est obligatoire!";
            isValid = false;
        }
        if (lastName == "") {
            error.lastName = "Le champ est obligatoire!";
            isValid = false;
        }
        // if (middleName == "") {
        //     error.middleName = "Le champ est obligatoire!";
        //     isValid = false;
        // }
        if (password == "") {
            error.password = "Le champ est obligatoire!";
            isValid = false;
        }
        if (addresse == "") {
            error.address = "Le champ est obligatoire!";
            isValid = false;
        }
        if (login == "") {
            error.login = "Le champ est obligatoire!";
            isValid = false;
        }
        if (phone == "") {
            error.phone = "Le champ est obligatoire!";
            isValid = false;
        }
        if (profil == "") {
            error.profil = "Le champ est obligatoire!";
            isValid = false;
        }
        setErrorForm(error);
        console.log({ error });
        if (isValid) {

            setIsLoading(true);
            axiosInstance.post(bUrl + "/agent-owner",
                //birthDay: birthDay,
                {
                    "firstName": firstName,
                    "lastName": lastName,
                    "middleName": middleName,
                    "phone": phone,
                    "email": emailUp,
                    "login": login,
                    "password": password,
                    "profil": profil,
                    "address": addresse,
                    "agentType": agentType,
                }
                , { header: header })
                .then(async (response) => {
                    //getDayOffDayEmmp(idEmp);
                    setIsLoading(false)

                    handleClose()
                    if (response?.data?.isError) {
                        const msg = errorMessage(response?.data?.code)
                        setErrorMsg(msg);
                        setShowError(true);
                    } else {
                        await postUserLog(bUrl + "/userLogs/addUserLogs", "Add User", response.data.body.login);
                        getListStaffs(email, phoneSh);
                    }

                })
                .catch(function (err) {
                    if (err?.response?.status == 401 || err?.response?.status == 403) {
                        setErrorMsg("Vous n'étes pas autorisé à faire cette opération!!")
                        setShowError(true);
                      } else {
                        let msg = errorMessage + ' ' + err?.response?.status ? (err?.response?.status) : '';
                        setErrorMsg(msg);
                        setShowError(true);
                      }

                    //console.log(err);
                    setShowError(true);
                });
        }
    }

    const { id } = useParams();
    const getListStaffs = async (email, phone) => {
        let ulr = "/owner-agent/find-all?page=" + currentPage + "&limit=10";

        setEmail(email);
        setPhoneSh(phone);
        if (phone != '' | email != '') {
            ulr = "/owner-agent/search?page=" + currentPage + "&limit=10";
            if (email != '') {
                ulr += "&email=" + email;
            }

            if (phone != '') {
                ulr += "&phone=" + phone;
            }
            
        }
        const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
            if (err?.response?.status == 401 || err?.response?.status == 403) {
                setErrorMsg("Vous n'étes pas autorisé à faire cette opération!!")
                setShowError(true);
              }else{
                let msg=ErrorMsg+ ' ' +err?.response?.status?(err?.response?.status):'';
                setErrorMsg(msg);
                setShowError(true);
              }
            setIsLoading(false)

        });
        if (response) {
            if (response?.data?.isError) {
                const msg = errorMessage(response?.data?.code)
                setErrorMsg(msg);
                setShowError(true);
            }
            if (response.status == 401) {
                navigate('/backoffice/login');
            }
            setListStaffs(response.data.body);
            setTotalPage(response.data.totalPage);
            setCurrentPage(response.data.currentPage);
            setIsLoading(false);

        }
    }
    const activeOrDeactiveStaff = () => { };
    const blokeOrDeblokeStaff = () => { };
    const postCutomers = async () => {

    }
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
        return new Date(dateString).toLocaleDateString(undefined, options)
    }
    useEffect(() => {
        if (sessionStorage.getItem("aname") === '' || sessionStorage.getItem("name") === null) {
            //console.log("----------GO GO GO ------------")
            navigate('/backoffice/login');
        }
        getListStaffs(email, phone);
    }, [currentPage])

    return (
        <div className="App">
            <div className="">


                <Sidebar />
                <section className="home ">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                                <div><p className='fw-bold'>Staff</p></div>
                                <div><Topbar /></div>
                            </div>

                            <div className="table-content mt-3 p-3">
                                <div className="d-flex justify-content-around">
                                    <div className="form-group text">
                                        <label htmlFor="exampleInputEmail1">Email</label>
                                        <input type="email" onChange={(e) => getListStaffs(e.target.value, phoneSh)} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
                                    </div>
                                    <div className="form-group text">
                                        <label htmlFor="phone">Phone</label>
                                        <input type="text" onChange={(e) => getListStaffs(email, e.target.value)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                                    </div>

                                </div>
                            </div>
                            <div className="table-content mt-3 p-3">


                                <button onClick={() => viewOpen()}>

                                    <i className='bx bxs-plus-circle icon'></i>
                                </button>
                                {/* <a href="/Home/Create" className="btn btn-primary mb-1"> </a> */}
                                <div className="table-responsive-xl">
                                    {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                                        <table className="table text">
                                            <thead>
                                                <tr>

                                                    <th scope="col">Id</th>
                                                    <th scope="col">Prénom</th>
                                                    <th scope="col">Deuxieme Nom</th>
                                                    <th scope="col">Nom</th>
                                                    <th scope="col">Téléphone</th>
                                                    <th scope="col">Email</th>
                                                    <th scope="col">Date</th>
                                                    <th scope="col">Profil</th>
                                                    <th scope="col">Login</th>
                                                    <th scope="col">Active</th>
                                                    <th scope="col">Bloque</th>
                                                    <th></th>
                                                    <th></th>

                                                </tr>
                                            </thead>

                                            <tbody>
                                                {ListStaffs.length > 0 ? ListStaffs.map((a, i) => {
                                                    return <tr key={i}>
                                                        <td>{i}</td>
                                                        <td>{a.firstName}</td>
                                                        <td>{a.middleName}</td>
                                                        <td>{a.lastName}</td>
                                                        <td>{a.phone}</td>
                                                        <td>{a.email}</td>
                                                        <td>{formatDate(a.createdDate)}</td>
                                                        <td>{a.profil}</td>
                                                        <td>{a.login}</td>
                                                        <td>
                                                            <label className="switch">
                                                                <input type="checkbox" className="i-btn" checked={a.isActive ? 'checked' : ''} onChange={(e) => handleShowConfirmActive(a.idOwnerAgent, e.target.checked)} />
                                                                <span className="slider-btn round"></span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label className="switch">
                                                                <input type="checkbox" className="i-btn" checked={a.isBlocked ? 'checked' : ''} onChange={(e) => handleShowConfirmBlocked(a.idOwnerAgent, e.target.checked)} />
                                                                <span className="slider-btn round"></span>
                                                            </label>

                                                        </td>
                                                        <td>
                                                            <i onClick={() => viewUpdate(a.idOwnerAgent, a.firstName, a.lastName, a.middleName, a.profil, a.address, a.login, a.phone, a.email)} className='bx bx-edit-alt colore-icon' title="Update"></i>
                                                        </td>
                                                    </tr>
                                                }) : <tr></tr>}
                                            </tbody>

                                        </table>
                                    }
                                </div>
                                <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
                            </div>

                        </div>
                    </div>
                </section>
            </div>
            <Modal show={view} onHide={handleClose} className="">
                <Modal.Header closeButton>
                    <Modal.Title className="text-center">Staff</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group mb-2">
                            <input type="text" placeholder="Prénom" name="name" className='form-control ' value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                            {errorForm.firstName != "" && <p style={{ color: 'red' }}>{errorForm.firstName}</p>}
                        </div>
                        <div className="form-group mb-2">
                            <input type="text" placeholder="Deuxieme Nom" name="name" className='form-control ' value={middleName} onChange={(e) => setMiddleName(e.target.value)} />
                            {errorForm.middleName != "" && <p style={{ color: 'red' }}>{errorForm.middleName}</p>}
                        </div>
                        <div className="form-group mb-2">
                            <input type="text" placeholder="Nom" name="lastName" className='form-control ' value={lastName} onChange={(e) => setLastName(e.target.value)} />
                            {errorForm.lastName != "" && <p style={{ color: 'red' }}>{errorForm.lastName}</p>}
                        </div>
                        <div className="form-group mb-2">
                            <input type="text" placeholder="Téléphone" name="tel" className='form-control ' value={phone} onChange={(e) => phonetOnchange(e)} />
                            {errorForm.phone != "" && <p style={{ color: 'red' }}>{errorForm.codeUp}</p>}
                        </div>
                        <div className="form-group mb-2">
                            <input type="text" placeholder="Login" name="login" className='form-control ' value={login} onChange={(e) => setLogin(e.target.value)} disabled={idUp !== ''} />
                            {errorForm.login != "" && <p style={{ color: 'red' }}>{errorForm.login}</p>}
                        </div>
                        <div className="form-group mb-2">
                            <input type="email" placeholder="email" name="email" className='form-control ' value={emailUp} onChange={(e) => setEmailUp(e.target.value)} />
                            {errorForm.emailUp != "" && <p style={{ color: 'red' }}>{errorForm.emailUp}</p>}
                        </div>
                        <div className="form-group mb-2">
                            <input type="text" placeholder="password" name="pwd" className='form-control ' value={password} onChange={(e) => setPassword(e.target.value)} />
                            {errorForm.password != "" && <p style={{ color: 'red' }}>{errorForm.password}</p>}
                        </div>
                        <div className="form-group mb-2">
                            <input type="text" placeholder="Adresse" name="adresse" className='form-control ' value={addresse} onChange={(e) => setAddress(e.target.value)} />
                            {errorForm.address != "" && <p style={{ color: 'red' }}>{errorForm.address}</p>}
                        </div>
                        <div className="form-group mb-2">
                            <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" value={profil} onChange={(e) => setProfil(e.target.value)}>
                                <option value="">Sélectionnez un profil</option>
                                <option value="CUSTOMER_SERVICE">Customer Services</option>
                                <option value="COMPTABLE">Comptable</option>
                                <option value="ADMIN">Admin</option>
                                <option value="SUPADMIN">super Admin</option>
                            </select>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    {idUp === '' ?
                        isLoading ?
                            <img src='../Custom.svg' width="3%" />
                            :
                            <Button variant="primary" onClick={addForm}>
                                Ajouter
                            </Button>
                        :
                        <Button variant="primary" onClick={updateForm}>
                            Modifier
                        </Button>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={showError} onHide={handleCloseError} className="">
                <Modal.Header closeButton className="bg-danger">
                    <Modal.Title>ERROR</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h5 className='text-danger' style={{ textAlign: 'center' }}>{ErrorMsg}</h5>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseError}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <ConfirmModal
                show={showModalConfirmActive}
                handleClose={handleCloseConfirmActive}
                handleConfirm={activeOrDeactiveUser}
            />

            <ConfirmModal
                show={showModalConfirmBlocked}
                handleClose={handleCloseConfirmBlocked}
                handleConfirm={blokeOrDeblokeUser}
            />

        </div>
    )
}